module.exports = "<!-- Generated template for the CounterWrapperComponent component -->\n\n<div (message)=\"handleMessageEvent($event)\">\n    <ng-content></ng-content>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/ion-wrapper/ion-wrapper.html
// module id = 7
// module chunks = 0 1